import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateAvailable } from 'store/modules/updateAvailable/actions';
import history from 'services/history';
import { renewPushSubscription } from 'services/push';
import type { ServiceWorkerClientMessage } from 'services/push';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

function isSafeAppPath(url: string): boolean {
  if (!url.startsWith('/') || url.startsWith('//')) {
    return false;
  }

  return true;
}

function navigateFromServiceWorker(url: string): void {
  if (!isSafeAppPath(url)) {
    return;
  }

  history.push(url);
}

// Registro único do service worker (também em app instalada / PWA)
const ServiceWorkerManager: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: () => {
        dispatch(
          updateAvailable({ update: true, downloadUpdates: false }),
        );
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return undefined;
    }

    function handleServiceWorkerMessage(event: MessageEvent): void {
      const data = event.data as ServiceWorkerClientMessage | undefined;
      if (!data?.type) {
        return;
      }

      if (data.type === 'OPEN_URL' && data.url) {
        navigateFromServiceWorker(data.url);
        return;
      }

      if (data.type === 'RENEW_PUSH_SUBSCRIPTION') {
        renewPushSubscription().catch(() => null);
      }
    }

    navigator.serviceWorker.addEventListener(
      'message',
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker.removeEventListener(
        'message',
        handleServiceWorkerMessage,
      );
    };
  }, []);

  return null;
};

export default ServiceWorkerManager;
